import { atom } from "jotai";
import { Refresh } from "../types/refresh";

export const refreshAtomRequest = atom<Refresh | null>(null);
